import React from 'react';

export const CalendarFilledIcon = ({ width = 32, height = 32, color = "white", className }) => {
    return (
        <svg
            width={width}
            height={height}
            viewBox="0 0 32 32"
            fill="none"
        >
            <path
                className={className}
                d="M28 26.6667V8.00008C28 6.52941 26.804 5.33341 25.3333 5.33341H22.6667V2.66675H20V5.33341H12V2.66675H9.33333V5.33341H6.66667C5.196 5.33341 4 6.52941 4 8.00008V26.6667C4 28.1374 5.196 29.3334 6.66667 29.3334H25.3333C26.804 29.3334 28 28.1374 28 26.6667ZM12 24.0001H9.33333V21.3334H12V24.0001ZM12 18.6667H9.33333V16.0001H12V18.6667ZM17.3333 24.0001H14.6667V21.3334H17.3333V24.0001ZM17.3333 18.6667H14.6667V16.0001H17.3333V18.6667ZM22.6667 24.0001H20V21.3334H22.6667V24.0001ZM22.6667 18.6667H20V16.0001H22.6667V18.6667ZM25.3333 12.0001H6.66667V9.33342H25.3333V12.0001Z"
                fill={color}
            />
        </svg>
    );
};